import type { FaqItem } from '../types/content'
import { siteConfig } from './siteConfig'

// Le domande con risposta vuota non vengono mostrate.
export const faqs: FaqItem[] = [
  {
    question: 'È adatto anche a chi parte da zero?',
    answer:
      'Sì. La guida introduce materiali, strumenti e passaggi di base. Puoi cominciare da forme semplici e procedere con la pratica, secondo i tuoi tempi.',
  },
  {
    question: 'Riceverò libri o materiali a casa?',
    answer:
      'No. Il pack contiene risorse digitali. Filati, tricotin, filo metallico e altri strumenti non sono inclusi.',
  },
  {
    question: 'I contenuti sono in italiano?',
    answer: 'Sì, le guide del pack sono in italiano.',
  },
  {
    question: 'Che cosa comprende il pack?',
    answer:
      'La guida Tricotin con Amore, La Collezione Creativa e quattro bonus dedicati a decorazioni, portachiavi, penne e bomboniere.',
  },
  {
    question:
      'Le raccolte Natale, Cerchi decorativi e Nascita, Battesimo e Comunione sono incluse?',
    answer: 'No. Sono raccolte aggiuntive acquistabili separatamente nel checkout.',
  },
  {
    question: 'È un abbonamento?',
    answer: 'No. Il pack prevede un pagamento unico.',
  },
  {
    question: 'Devo stampare tutto?',
    answer:
      'Puoi consultare le guide in formato digitale e stampare i cartamodelli che desideri utilizzare.',
  },
  {
    question: 'Come ricevo i file?',
    answer: siteConfig.deliveryAnswer,
  },
  {
    question: 'Posso vendere le mie creazioni?',
    answer: siteConfig.commercialUseAnswer,
  },
  {
    question: 'È prevista una garanzia o un rimborso?',
    answer: siteConfig.refundAnswer,
  },
]
